/**
 * TODO
 * THIS IS COPIED FROM SKYSLOPE MACHE AND IDEALLY WE COULD JUST UPDATE
 * TO THE LATEST VERSION OF MACHE BUT THIS CODEBASE IS CURRENTLY WAYYYY
 * BEHIND.
 */
import React from 'react';
import { useStorage, type UseStorageApi } from './use-storage';

export function useLocalStorage<T = string>(key: string): UseStorageApi<T | null>;
export function useLocalStorage<T = string>(key: string, defaultValue: T): UseStorageApi<T>;
export function useLocalStorage<T = string>(key: string, defaultValue?: T) {
  const getStorage = React.useCallback(
    () => (typeof window === 'undefined' ? null : window.localStorage),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- This code was written prior to enforcing lint rules
    [typeof window]
  );
  return useStorage<T>(key, getStorage, defaultValue);
}
